<!-- 
* @Description 超级管理员后台
-->
<template>
  <div id="box">
    <div id="box-left">
      <div class="one">
        <div>
          <div class="title">店铺概况</div>
          <div class="content">
            <div>
              <div>总店铺数</div>
              <div>包含即将过期已过期的总店铺</div>
              <div>
                <CountTo :start-val="0" :end-val="topData.total"></CountTo>
              </div>
            </div>
            <div>
              <div>今日新增</div>
              <div>今日新增的店铺</div>
              <div>
                <CountTo :start-val="0" :end-val="topData.today"></CountTo>
              </div>
            </div>
            <div>
              <div>昨日新增</div>
              <div>昨日新增的店铺</div>
              <div>
                <CountTo :start-val="0" :end-val="topData.yesterday"></CountTo>
              </div>
            </div>
            <div>
              <div>近七日新增</div>
              <div>近七日新增的店铺</div>
              <div>
                <CountTo :start-val="0" :end-val="topData.week"></CountTo>
              </div>
            </div>
            <div>
              <div>即将过期</div>
              <div>近30天内即将到期的店铺</div>
              <div>
                <CountTo :start-val="0" :end-val="topData.due_soon"></CountTo>
              </div>
            </div>
            <div>
              <div>已过期</div>
              <div>已经到期未删除的店铺</div>
              <div>
                <CountTo :start-val="0" :end-val="topData.expired"></CountTo>
              </div>
            </div>
          </div>
        </div>
        <div>
          <div class="title">快捷入口</div>
          <div class="content">
            <div>
              <img src="./imgs/icon-1.png" @click="toRoute('/store/list')" />
              <div>店铺审核</div>
            </div>
            <div>
              <img src="./imgs/icon-2.png" @click="toRoute('/store/edit')" />
              <div>创建店铺</div>
            </div>
            <div>
              <img src="./imgs/icon-3.png" @click="toRoute()" />
              <div>创建套餐</div>
            </div>
            <div>
              <img src="./imgs/icon-4.png" @click="toRoute()" />
              <div>新增用户</div>
            </div>
            <div>
              <img src="./imgs/icon-5.png" @click="toRoute()" />
              <div>广告管理</div>
            </div>
            <div>
              <img src="./imgs/icon-6.png" @click="toRoute('none')" />
              <div>帮助文档</div>
            </div>
            <div>
              <img src="./imgs/icon-7.png" @click="toRoute('/applist')" />
              <div>应用中心</div>
            </div>
            <div>
              <img src="./imgs/icon-8.png" @click="toRoute()" />
              <div>立即续费</div>
            </div>
            <div>
              <img src="./imgs/icon-9.png" @click="toRoute()" />
              <div>修复更新</div>
            </div>
            <div>
              <img src="./imgs/icon-10.png" @click="toRoute()" />
              <div>更新日志</div>
            </div>
          </div>
        </div>
      </div>
      <div class="three">
        <div>
          <div class="title">
            <div>店铺与会员新增</div>
            <div class="title-buttons">
              <!-- <el-button type="primary" size="mini">今日</el-button> -->
              <!-- <el-button type="primary" size="mini">昨日</el-button> -->
              <el-button
                :type="echarts1DateSelect === 1 ? 'primary' : 'default'"
                size="mini"
                @click="setcharts1(1)"
                >7日</el-button
              >
              <el-button
                :type="echarts1DateSelect === 2 ? 'primary' : 'default'"
                size="mini"
                @click="setcharts1(2)"
                >近30日</el-button
              >
            </div>
          </div>
          <div class="content">
            <div class="left">
              <div class="item active">
                <div>新增店铺数</div>
                <div>包含待创建、待审核、已审核通过店铺</div>
                <div>{{ addShopNum }}</div>
              </div>
              <div class="item" @click="$message('功能开发中，敬请期待！')">
                <div>新增会员数</div>
                <div>包含待审核、已审核通过会员</div>
                <div>0</div>
              </div>
            </div>
            <div class="right">
              <div id="echarts1" style="height: 350px; width: auto"></div>
            </div>
          </div>
        </div>
      </div>
      <div class="four">
        <div class="left">
          <div class="title">
            <div>店铺销售排行</div>
            <div class="buttons">
              <el-button
                t
                :type="shopRankingSelect === 1 ? 'primary' : 'default'"
                size="mini"
                @click="shopRankingSelect = 1"
                >本月</el-button
              >
              <el-button
                :type="shopRankingSelect === 2 ? 'primary' : 'default'"
                size="mini"
                @click="shopRankingSelect = 2"
                >全部</el-button
              >
            </div>
          </div>
          <div class="content">
            <el-table
              :data="tableData"
              border
              style="width: 100%"
              :header-cell-style="{ background: '#F4F6F8', padding: '20px 0' }"
            >
              <el-table-column
                type="index"
                label="排行"
                width="10%"
                align="center"
              >
                <template slot-scope="{ $index }">
                  <img
                    src="./imgs/one.png"
                    style="
                      width: 40px;
                      height: 40px;
                      position: relative;
                      top: 5px;
                    "
                    alt=""
                    v-if="$index === 0"
                  />
                  <img
                    src="./imgs/two.png"
                    style="
                      width: 40px;
                      height: 40px;
                      position: relative;
                      top: 5px;
                    "
                    alt=""
                    v-else-if="$index === 1"
                  />
                  <img
                    src="./imgs/three.png"
                    style="
                      width: 40px;
                      height: 40px;
                      position: relative;
                      top: 5px;
                    "
                    alt=""
                    v-else-if="$index === 2"
                  />
                  <div class="index" v-else>{{ $index + 1 }}</div>
                </template>
              </el-table-column>
              <el-table-column
                prop="name2"
                label="店铺名称"
                width="20%"
                align="center"
              >
                <template slot-scope="{ row }">
                  <div
                    style="
                      display: flex;
                      align-items: center;
                      justify-content: center;
                    "
                  >
                    <img
                      src="./imgs/shop.png"
                      style="width: 40px; height: 40px"
                      alt=""
                    />
                    <span
                      style="
                        margin-left: 8px;
                        overflow: hidden;
                        text-overflow: ellipsis;
                        white-space: nowrap;
                      "
                      >{{ row.name2 }}</span
                    >
                  </div>
                </template>
              </el-table-column>
              <el-table-column
                prop="name3"
                label="店铺类型"
                width="20%"
                align="center"
              >
              </el-table-column>
              <el-table-column
                prop="name4"
                label="销售额"
                width="20%"
                align="center"
              >
              </el-table-column>
              <el-table-column
                prop="name5"
                label="注册时间"
                width="22%"
                align="center"
              >
              </el-table-column>
            </el-table>
          </div>
        </div>
        <div class="right">
          <div class="title">
            <div>店铺流量排行</div>
            <div class="buttons">
              <el-button type="primary" size="mini">会员数量</el-button>
            </div>
          </div>
          <div class="content">
            <el-table
              :data="tableData"
              border
              style="width: 100%"
              :header-cell-style="{ background: '#F4F6F8', padding: '20px 0' }"
            >
              <el-table-column
                label="排行"
                width="10%"
                type="index"
                align="center"
              >
                <template slot-scope="{ $index }">
                  <img
                    src="./imgs/one.png"
                    style="
                      width: 40px;
                      height: 40px;
                      position: relative;
                      top: 5px;
                    "
                    alt=""
                    v-if="$index === 0"
                  />
                  <img
                    src="./imgs/two.png"
                    style="
                      width: 40px;
                      height: 40px;
                      position: relative;
                      top: 5px;
                    "
                    alt=""
                    v-else-if="$index === 1"
                  />
                  <img
                    src="./imgs/three.png"
                    style="
                      width: 40px;
                      height: 40px;
                      position: relative;
                      top: 5px;
                    "
                    alt=""
                    v-else-if="$index === 2"
                  />
                  <div class="index" v-else>{{ $index + 1 }}</div>
                </template>
              </el-table-column>
              <el-table-column
                prop="name2"
                label="店铺名称"
                width="20%"
                align="center"
              >
                <template slot-scope="{ row }">
                  <div
                    style="
                      display: flex;
                      align-items: center;
                      justify-content: center;
                    "
                  >
                    <img
                      src="./imgs/shop.png"
                      style="width: 40px; height: 40px"
                      alt=""
                    />
                    <span
                      style="
                        margin-left: 8px;
                        overflow: hidden;
                        text-overflow: ellipsis;
                        white-space: nowrap;
                      "
                      >{{ row.name2 }}</span
                    >
                  </div>
                </template>
              </el-table-column>
              <el-table-column
                prop="name3"
                label="店铺类型"
                width="20%"
                align="center"
              >
              </el-table-column>
              <el-table-column
                prop="name4"
                label="会员数量"
                width="20%"
                align="center"
              >
              </el-table-column>
              <el-table-column
                prop="name5"
                label="注册时间"
                width="22%"
                align="center"
              >
              </el-table-column>
            </el-table>
          </div>
        </div>
      </div>
    </div>
    <div id="box-right">
      <!-- 更新日志 -->
      <div class="one">
        <div class="title">
          <div>更新日志</div>
          <div>查看更多></div>
        </div>
        <div class="content">
          <el-timeline>
            <el-timeline-item
              v-for="(activity, index) in activities"
              :key="index"
              :timestamp="activity.timestamp"
            >
              <template #default>
                <div
                  style="
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                  "
                >
                  <div style="font-size: 14px; font-weight: bold">
                    {{ activity.content }}
                  </div>
                  <div>
                    {{ activity.date }}
                  </div>
                </div>
              </template>
              <!-- {{ activity.content }} -->
            </el-timeline-item>
          </el-timeline>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import echarts from "echarts";
import { eltips } from "@/util/util.js";
import CountTo from "@/views/apps/common/components/CountTo.vue";

export default {
  name: "index",
  data() {
    return {
      echarts1DateSelect: 2,
      echart1Data: [],
      addShopNum: 0,
      shopRankingSelect: 1,
      topData: {
        due_soon: 0,
        expired: 0,
        today: 0,
        total: 0,
        week: 0,
        yesterday: 0,
      },
      tableData: [
        {
          name2: "王小虎",
          name3: "但店铺",
          name4: "1546",
          name5: "2021-12-02 15:53:34",
        },
        {
          name2: "王小虎",
          name3: "但店铺",
          name4: "1546",
          name5: "2021-12-02 15:53:34",
        },
        {
          name2: "王小虎",
          name3: "但店铺",
          name4: "1546",
          name5: "2021-12-02 15:53:34",
        },
        {
          name2: "王小虎",
          name3: "但店铺",
          name4: "1546",
          name5: "2021-12-02 15:53:34",
        },
        {
          name2: "王小虎",
          name3: "但店铺",
          name4: "1546",
          name5: "2021-12-02 15:53:34",
        },
      ],
      activities: [
        {
          content: "5.20.2",
          date: "2023-04-24 17:47:40",
          timestamp:
            "优化【单-移动端】【多-移动端】-页面样式优化，包括商品详情页、订单列表页、订单详情页，以及秒杀、拼团、预售等营销活动有关页面修复【单-商家端】【多-平台端】【多-商户端】设为顶部菜单样式，各页面顶部间距问题,修复【单-商家端】【多-平台端】【多-商户端】上传发货信息关闭后保存失败问题,修复【多-平台端】创建店铺后选择付费套餐后，页面一直加载问题,修复【单-移动端】【多-移动端】装修-个人中心页，修改后台积分排行自定义文字设置不更新问题,修复【单-移动端】【多-移动端】装修-首页，设置标签页为单列主图时，图片未更改问题,修复【单-商家端】【多-平台端】营销-优惠券手动发券页面样式问题,修复【单-商家端】【多-平台端】【多-商户端】退款后数据看板不同步问题,修复【单-移动端】【多-移动端】快捷购买商品中减少数量时页面报错问题,修复【管理端】小程序升级无权限时的提示语",
        },
        {
          content: "5.20.1",
          date: "2023-04-20 16:51:25",
          timestamp:
            "修复【单-商家端】计次时核销应用提示暂无权限问题,修复【单-移动端】核销台-核销员使用绑定的核销点核销时，提示无权限问题",
        },
        {
          content: "5.20.0",
          date: "2023-04-20 09:53:15",
          timestamp:
            "新增【本次更新需要重新上传小程序】,新增【管理端】-新增核销优惠券应用，适配单店铺，兼容门店模式,新增【管理端】-新增一套美容行业的装修模板,新增【商家端】-新增核销优惠券应用，优惠券支持在店铺助手小程序、收银台、移动端个人中心的核销入口进行核销，支持直接扣减收银台的订单金额。帮助商家实现引流到店、提高转化率,新增【商家端】-核角色权限、操作日志兼容适配核销优惠券,新增【单-移动端】-优惠券详情支持查看核销码，可出示给商家扫码核验,新增【店铺助手小程序】-支持验证核销优惠券，核销成功后产生记录,新增【收银台端】-支持验证核销优惠券，使订单结算金额享受优惠；支持直接验证核销优惠券，核销成功后产生记录,新增【收银台端】-核销版块新增“查看核销记录”入口以及详细信息修复【管理端】-店铺域名OEM增加限制，授权域名不可作为自定义域名,修复【单-商家端】【多-平台端】【多-商户端】-首页运营数据退款金额统计错误的问题,修复【单-商家端】【多-平台端】【多-商户端】-订单关键词搜索搜索项未显示完全的问题,修复【单-商家端】【多-商户端】-打印小票分销商信息与商城内不一致的问题,修复【单-商家端】-新人送礼奖励优惠券发放数量超出总数的问题,修复【单-移动端】【多-移动端】-自定义页面设置浏览权限访问时白屏的问题,修复【单-移动端】【多-移动端】-充值奖励活动没有赠送奖励的问题,修复【单-移动端】-价格为0元的积分商城商品，错误显示金额0的问题,修复【单-移动端】【多-移动端】优惠券详情页面问题,修复【单-商家端】【多-平台端】【多-商户端】添加商品，删除、修改轮播图问题,修复【单-商家端】【多-平台端】【多-商户端】渠道注册设置中的提示文字有错别字,修复【单-商家端】【多-商户端】下单选择同城配送，商品单品维权后剩余商品无法发货问题,修复【多-平台端】商品管理，面包屑导航栏错误,修复【单-商家端】【多-商户端】商品详情页页圆角设置改变后展示不正确问题,修复【单-商家端】【多-商户端】快速购买页面因页面无法下拉，导致最后一个商品无法添加至购物车问题",
        },
        {
          content: "5.19.3",
          date: "2023-04-13 09:25:25",
          timestamp:
            "新增【单-商家端】【多-平台端】-新增再次购买功能，启用后支持买家对已完成的订单商品一键快捷购买优化【单-商家端/门店端】【多-平台端/商户端】-商品选择器支持安商品的类型、分类、分组进行快捷搜索筛选；支持对当前搜索结果全选,优化【单-商家端/门店端】【多-平台端/商户端】-商品编辑新增“单列主图”设置项，满足同时使用方形主图和单列主图的场景,优化【单-商家端/门店端】【多-平台端/商户端】-当面付保存后支持编辑小票打印和语音播报设置,优化【单-商家端/门店端】【多-平台端/商户端】-图片/视频选择器和素材库支持按文件名进行搜索,优化【单-商家端/门店端】【多-平台端/商户端】-电子面单模板支持邮政快递一联和顺丰电商标快一联,优化【单-商家端/门店端】【多-平台端/商户端】-订单待收货列表页，新增全部/待收货/待核销标签页，方便对待核销的管理,优化【单-商家端】【多-平台端/商户端】-首页运营数据的退款金额优化，计入后台主动对订单进行退款的金额,优化【单-商家端】【多-平台端/商户端】-系统表单、自定义表单的单选和多选，支持批量添加选项,优化【单-商家端】【多-平台端】-支持对移动端商品详情页的会员价标签进行设置开启/关闭,优化【单-商家端】【多-平台端】-链接选择器调整“会员充值”链接名称为“余额管理”；新增“余额充值”链接,优化【单-商家端】【多-平台端】-财务余额明细列表内，对于后台修改最终余额的，修正余额变动数值的核算方式,优化【单-商家端】【多-平台端】-店铺风格添加小程序弹窗支持自定义,优化【单-商家端】【多-平台端】-小程序渠道支持启用自动上传发货信息功能，对于商家自营类目的小程序，解决手动上传订单到微信公众平台小程序后台的繁琐问题,优化【单-商家端】【多-商户端】-订单改价支持一键改为0元,优化【单-商家端】-计次时商品支持对单品设置消费得积分,优化【多-商户端】-订单支持商户主动“确认核销”,优化【单-门店端】-新建入库单支持批量设置入库数量,优化【单-移动端】【多-移动端】-商品详情页的会员价标签，优化调整为：实际享受了会员时才显示标签,优化【管理端】-店铺的应用授权支持批量勾选后进行显示/隐藏设置修复【单-商家端】【多-平台端】-商品组修改商品顺序无效的问题,修复【单-商家端】【多-平台端】-商品助手抓取1688链接报错的问题,修复【单-商家端】【单-门店端】-收银台应用收银员搜索字段显示错误的问题,修复【单-商家端】-供货商应用供货商端首页样式问题,修复【多-商户端】-关闭商户认证后，商户端无法添加商品的问题,修复【单-移动端】【多-移动端】-装修自定义表单组件下间距过大的问题,修复【单-移动端】【多-移动端】-装修秒杀组件划线价不显示的问题,修复【单-移动端】【多-移动端】-装修的拼团组件成团人数错误的问题,修复【单-移动端】【多-移动端】-装修店铺笔记组件文章显示不全的问题,修复【单-移动端】【多-移动端】-自定义页面不显示悬浮窗的问题,修复【单-微信小程序渠道】【多-微信小程序渠道】-小程序加载中先显示底部版权的问题,修复【单-微信小程序渠道】【多-微信小程序渠道】-商品列表中商品划线价不显示的问题",
        },
        {
          content: "5.19.2",
          date: "2023-04-06 17:58:58",
          timestamp:
            "修复【需要重新上传小程序】,修复【单-微信小程序渠道】【多-微信小程序渠道】-无法进入自定义页面的问题",
        },
        {
          content: "5.19.1",
          date: "2023-04-06 14:23:34",
          timestamp:
            "修复【单-收银台端】-登陆页刷新显示404的问题，修复【单-收银台端】-登陆页面跳转显示文字错误的问题",
        },
        {
          content: "v5.19.0",
          date: "2023-04-06 09:39:39",
          timestamp:
            "【管理端】【单-商家端/门店端】-收银台应用，适配单店铺商家端、门店端，订单详情的商品规格显示优化，解决显示不全问题",
        },
        // {
        //   content: "5.18.7",
        //   date: "2023-03-30 09:22:25",
        //   timestamp: "【多-平台端】-交易设置的订单自动完成时间放开为1-30天",
        // },
      ],
    };
  },
  components: {
    CountTo,
  },
  created() {
    //折线数量
    // this.homePageIncrease();
    //头部统计
    this.homePageStatistic();
  },
  async mounted() {
    //折线图
    await this.homePageLine();
    this.setcharts1();
  },
  methods: {
    toRoute(path) {
      this.$message("功能开发中，敬请期待！");
      // if (path === "none") {
      //   this.$message("功能开发中，敬请期待！");
      // } else {
      //   this.$router.push(path);
      // }
    },
    // 折线图
    async homePageLine() {
      await this.axios
        .get("/api/home_page_line", {
          params: {},
        })
        .then((res) => {
          if (res.code == 200) {
            this.echart1Data = res.data;
          } else {
            eltips(res.msg, "error");
          }
        });
    },
    // 折线数量
    // homePageIncrease() {
    //   this.axios
    //     .get("/api/home_page_increase", {
    //       params: {},
    //     })
    //     .then((res) => {
    //       if (res.code == 200) {
    //         console.log("折线数量res", res);
    //         // this.list = [];
    //         // res.data.map((item) => {
    //         //   this.list.push({
    //         //     title: item.app_name,
    //         //     number: item.user_count,
    //         //     filed: item.id,
    //         //   });
    //         // });

    //         // if (cover) {
    //         //   this.filed = res.data[0].id;
    //         //   this.setcharts();
    //         // }
    //       } else {
    //         eltips(res.msg, "error");
    //       }
    //     });
    // },
    // 头部统计
    homePageStatistic() {
      this.axios.get("/api/home_page_statistics").then((res) => {
        if (res.code == 200) {
          // console.log("res头部统计", res);
          this.topData = res.data;
        } else {
          eltips(res.msg, "error");
        }
      });
    },
    setcharts1(date = 2) {
      this.echarts1DateSelect = date;
      let echart1Data = [];
      if (date === 1) {
        echart1Data = this.echart1Data.slice(0, 7);
      } else {
        echart1Data = this.echart1Data;
      }
      const xData = echart1Data.map((item) => {
        return item.time;
      });
      const seriesData = echart1Data.map((item) => {
        return item.count;
      });
      this.addShopNum = seriesData.reduce((a, b) => Number(a) + Number(b), 0);
      const charts = echarts.init(document.getElementById("echarts1"));
      const option = {
        grid: {
          left: "5%",
          right: "5%",
          bottom: "0%",
          containLabel: true,
        },
        legend: {
          data: ["新增店铺数"],
          top: "3%",
          right: "5%",
          textStyle: {
            color: "#9d9d9d",
          },
          icon: "circle",
          itemWidth: 13,
          itemHeight: 13,
          itemStyle: {
            color: "#5883FE",
          },
        },
        // title: [
        //   {
        //     text: `${day}${label}总计：{style|${seriesDataTotal}}  ${unit}`,
        //     left: "5%",
        //     top: "1%",
        //     textStyle: {
        //       fontSize: 12,
        //       color: "#9d9d9d",
        //       // fontWeight: "bold",
        //       rich: {
        //         style: {
        //           fontWeight: "bold",
        //           fontSize: 20,
        //           color: "#000",
        //         },
        //       },
        //     },
        //   },
        // ],
        xAxis: {
          type: "category",
          data: xData,
          axisLine: {
            show: false,
          },
          boundaryGap: false,
          // axisLabel: {
          //   interval: 1, // 设置标签显示间隔，0 表示显示所有标签
          // },
        },
        yAxis: {
          name: "单位（个）",
          type: "value",
          axisLine: {
            show: false,
          },
        },
        series: [
          {
            data: seriesData,
            name: "新增店铺数",
            type: "line",
            symbol: "circle",
            showSymbol: false,
            hoverAnimation: true,
            lineStyle: {
              width: 3,
              color: "#0D4CFD",
            },
            smooth: true,
            areaStyle: {
              color: "#0D4CFD",
              opacity: 0.2,
            },
          },
        ],
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "line",
            lineStyle: {
              type: "dashed",
              color: "#F43054",
            },
          },
          // formatter: function (params) {
          //   // return params.name
          //   return (
          //     params[0].name +
          //     "<br/>支付金额：<span style='color:#F43054'>" +
          //     params[0].value
          //   );
          // },
        },
      };
      charts.setOption(option);
    },
  },
};
</script>

<style lang="less" scoped>
div {
  font-family: "PingFang SC", "Helvetica Neue", Helvetica, "Hiragino Sans GB",
    "Microsoft YaHei", "微软雅黑", Arial, sans-serif !important;
  -webkit-font-smoothing: antialiased;
  color: rgb(44, 62, 80);
}
#box {
  display: flex;
  padding: 10px;
  > #box-left {
    width: 86%;
    // 公共
    > .one,
    > .two,
    > .three,
    > .four {
      margin-top: 20px;
      display: flex;
      justify-content: space-between;
      // 每个模块
      > div {
        background-color: #ffffff;
        border-radius: 10px;
        padding: 20px;
        .content {
          > div {
            border-radius: 10px;
          }
        }
      }
    }
    > .one {
      margin-top: 0;
      display: flex;
      justify-content: space-between;
      // 店铺概况
      > div:nth-child(1) {
        width: 49.5%;
        > .title {
          font-size: 20px;
          font-weight: 600;
          color: #262b30;
          margin-left: 13px;
          position: relative;
        }
        > .title::before {
          position: absolute;
          content: "";
          width: 3px;
          height: 20px;
          left: -10px;
          top: 5px;
          background: linear-gradient(0deg, #1989fa, #1989fa), #262b30 !important;
          box-sizing: border-box;
        }
        > .content {
          display: flex;
          flex-wrap: wrap;
          justify-content: space-around;
          cursor: pointer;
          > div {
            width: 31%;
            background: linear-gradient(0deg, #fbfbfb, #fbfbfb), #fafafa;
            margin-top: 20px;
            padding: 10px;
            // 标题
            > div:nth-child(1) {
              font-size: 16px;
              font-weight: 600;
              color: #262b30;
              line-height: 22px;
            }
            // 描述
            > div:nth-child(2) {
              margin-top: 10px;
              color: #939799;
              font-size: 12px;
              // 一行显示
              white-space: nowrap;
            }
            // 数量
            > div:nth-child(3) {
              font-size: 30px;
              font-weight: 700;
              color: #4390ff;
              margin-top: 10px;
            }
          }
        }
      }
      // 快捷入口
      > div:nth-child(2) {
        width: 49.5%;
        > .title {
          font-size: 20px;
          font-weight: 600;
          color: #262b30;
          margin-left: 13px;
          position: relative;
        }
        > .title::before {
          position: absolute;
          content: "";
          width: 3px;
          height: 20px;
          left: -10px;
          top: 5px;
          background: linear-gradient(0deg, #1989fa, #1989fa), #262b30 !important;
          box-sizing: border-box;
        }
        > .content {
          display: flex;
          flex-wrap: wrap;
          justify-content: space-between;
          margin-top: 40px;
          cursor: pointer;
          > div {
            width: 12%;
            text-align: center;
            margin: 10px 20px;
            > img {
              width: 60px;
              height: 60px;
            }
            > div:nth-child(2) {
              margin-top: 3px;
              font-size: 16px;
              font-weight: 600;
            }
          }
        }
      }
    }
    // > .two {
    //   > div:nth-child(1) {
    //     width: 49.5%;
    //     height: 100px;
    //   }
    //   > div:nth-child(2) {
    //     width: 49.5%;
    //     height: 100px;
    //   }
    // }
    > .three {
      // 店铺与会员新增
      > div:nth-child(1) {
        width: 100%;
        > .title {
          display: flex;
          justify-content: space-between;
          margin-bottom: 40px;
          > div:nth-child(1) {
            font-size: 20px;
            font-weight: 600;
            color: #262b30;
            margin-left: 13px;
            position: relative;
          }
          > div:nth-child(1)::before {
            position: absolute;
            content: "";
            width: 3px;
            height: 20px;
            left: -10px;
            top: 5px;
            background: linear-gradient(0deg, #1989fa, #1989fa), #262b30 !important;
            box-sizing: border-box;
          }
          > .title-buttons {
            .el-button:nth-child(1) {
              border-right: none !important;
            }
            .el-button:nth-child(2) {
              border-left: none !important;
            }
          }
        }
        > .content {
          display: flex;
          > .left {
            width: 30%;
            margin-left: 50px;
            > .active {
              background: rgba(25, 137, 250, 0.1) !important;
              border: 1px solid #1989fa !important;
            }
            > .item {
              background: #fafafa;
              border: 1px solid #fafafa;
              border-radius: 10px;
              padding: 20px;
              width: 246px;
              -webkit-box-sizing: border-box;
              box-sizing: border-box;
              cursor: pointer;
              > div:nth-child(1) {
                color: #262b30;
                font-size: 16px;
                font-weight: 600;
              }
              > div:nth-child(2) {
                font-size: 12px;
                color: #939799;
                margin-top: 6px;
              }
              > div:nth-child(3) {
                margin-top: 10px;
                font-size: 30px;
                font-weight: 700;
                color: #636669;
              }
            }
            > .item:nth-child(2) {
              margin-top: 40px;
            }
          }
          > .right {
            width: 70%;
            > #echarts1 {
              position: relative;
              right: 10%;
            }
          }
        }
      }
    }
    > .four {
      // 店铺销售排行
      > .left {
        width: 49.5%;
        > .title {
          display: flex;
          justify-content: space-between;
          margin-bottom: 20px;
          > div:nth-child(1) {
            font-size: 20px;
            font-weight: 600;
            color: #262b30;
            margin-left: 13px;
            position: relative;
          }
          > div:nth-child(1)::before {
            position: absolute;
            content: "";
            width: 3px;
            height: 20px;
            left: -10px;
            top: 5px;
            background: linear-gradient(0deg, #1989fa, #1989fa), #262b30 !important;
            box-sizing: border-box;
          }
        }
        > .content {
          .el-table {
            color: #262b30 !important;
          }
        }
      }
      // 店铺流量排行
      > .right {
        width: 49.5%;
        > .title {
          display: flex;
          justify-content: space-between;
          margin-bottom: 20px;
          > div:nth-child(1) {
            font-size: 20px;
            font-weight: 600;
            color: #262b30;
            margin-left: 13px;
            position: relative;
          }
          > div:nth-child(1)::before {
            position: absolute;
            content: "";
            width: 3px;
            height: 20px;
            left: -10px;
            top: 5px;
            background: linear-gradient(0deg, #1989fa, #1989fa), #262b30 !important;
            box-sizing: border-box;
          }
        }
        > .content {
          .el-table {
            color: #262b30 !important;
          }
        }
      }
    }
  }
  > #box-right {
    width: 14%;
    margin-left: 20px;
    // 更新日志
    > .one {
      background-color: #ffffff;
      border-radius: 10px;
      padding-bottom: 7px;
      position: fixed;
      margin-right: 30px;
      > .title {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 20px;
        > div:nth-child(1) {
          color: #262b30;
          font-size: 20px;
          font-weight: 600;
        }
        > div:nth-child(2) {
          cursor: pointer;
          font-size: 12px;
          line-height: 16px;
          color: #97754f !important;
          display: flex;
          align-items: center;
          img {
            width: 15px;
          }
        }
      }
      > .content {
        padding: 20px;
        padding-top: 0;
        // 标题
        /deep/.el-timeline-item__content {
          font-size: 12px;
        }
        // 内容
        /deep/.el-timeline-item__timestamp {
          margin-top: 10px;
          font-size: 12px;
          line-height: 16px;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 2;
          color: #262b30;
          margin-bottom: 20px;
          //
          font-family: "PingFang SC", "Helvetica Neue", Helvetica,
            "Hiragino Sans GB", "Microsoft YaHei", "微软雅黑", Arial, sans-serif !important;
          -webkit-font-smoothing: antialiased;
          color: rgb(44, 62, 80);
        }
      }
    }
  }
}
// 公共
/deep/.el-table .el-table__body td {
  border-right: none !important;
  // border-bottom: none !important;
}
/deep/.el-table .el-table__header th {
  border-right: none !important;
  // border-bottom: none !important;
}
/deep/.el-table__header,
/deep/.el-table__body {
  width: 100% !important;
}
/deep/ .el-timeline-item__tail {
  border-left: 2px solid #f2ca8f;
}
/deep/ .el-timeline-item__node {
  border: 1px solid #f2ca8f;
  background-color: #fff;
}
/deep/ .el-button {
  padding: 8px 23px;
  // color: #515a6e;
  // background: linear-gradient(0deg, #fff9f2, #fff9f2), #e3bd76;
  // min-width: 100px;
  border: 1px solid rgba(220, 222, 226, 0.3) !important;
  box-sizing: border-box;
  line-height: 18px;
  height: auto;
  border-radius: 6px;
  margin: 0;
}
</style>